// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Help        = require("./Help");
var Block       = require("bs-platform/lib/js/block.js");
var Board       = require("./Board");
var Curry       = require("bs-platform/lib/js/curry.js");
var React       = require("react");
var Tetris      = require("../lib/Tetris");
var GameOver    = require("./GameOver");
var EventLayer  = require("./EventLayer");
var Js_boolean  = require("bs-platform/lib/js/js_boolean.js");
var Pervasives  = require("bs-platform/lib/js/pervasives.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./App.css')));

var theme = (require('../media/theme.mp3'));

var mute = (require('../media/mute.svg'));

var unmute = (require('../media/unmute.svg'));

function elementState(label, value) {
  return React.createElement("div", undefined, React.createElement("h2", undefined, label), React.createElement("h3", undefined, Pervasives.string_of_int(value)));
}

function takeAction(state, action) {
  return /* Update */Block.__(0, [/* record */[
              /* game */Tetris.act(state[/* game */0], action),
              /* softDrop */state[/* softDrop */1],
              /* isMuted */state[/* isMuted */2],
              /* isPaused */state[/* isPaused */3],
              /* timerId */state[/* timerId */4]
            ]]);
}

function setTimer(game, softDrop, reduce) {
  var prevLevel = Tetris.getLevel(game) - 1 | 0;
  return /* Some */[setInterval(Curry._1(reduce, (function () {
                      return /* Tick */0;
                    })), 1000.0 / (
                softDrop !== 0 ? 20.0 : 1.0
              ) * Math.pow(0.8 - 0.007 * prevLevel, prevLevel) | 0)];
}

var component = ReasonReact.reducerComponent("App");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      self[/* state */2][/* timerId */4][0] = setTimer(self[/* state */2][/* game */0], self[/* state */2][/* softDrop */1], self[/* reduce */1]);
      return /* NoUpdate */0;
    });
  newrecord[/* didUpdate */5] = (function (param) {
      var newSelf = param[/* newSelf */1];
      var oldSelf = param[/* oldSelf */0];
      var levelChanged = +(Tetris.getLevel(oldSelf[/* state */2][/* game */0]) !== Tetris.getLevel(newSelf[/* state */2][/* game */0]));
      var softDropChanged = +(oldSelf[/* state */2][/* softDrop */1] !== newSelf[/* state */2][/* softDrop */1]);
      var match = levelChanged || softDropChanged;
      if (match !== 0) {
        var match$1 = oldSelf[/* state */2][/* timerId */4][0];
        if (match$1) {
          clearInterval(match$1[0]);
        }
        newSelf[/* state */2][/* timerId */4][0] = setTimer(newSelf[/* state */2][/* game */0], newSelf[/* state */2][/* softDrop */1], newSelf[/* reduce */1]);
        return /* () */0;
      } else {
        return /* () */0;
      }
    });
  newrecord[/* render */9] = (function (param) {
      var state = param[/* state */2];
      var reduce = param[/* reduce */1];
      var match = state[/* isMuted */2];
      return React.createElement("div", {
                  onKeyDown: Curry._1(reduce, (function (e) {
                          return /* KeyDown */Block.__(0, [e.which]);
                        })),
                  onKeyUp: Curry._1(reduce, (function (e) {
                          return /* KeyUp */Block.__(1, [e.which]);
                        }))
                }, ReasonReact.element(/* None */0, /* None */0, EventLayer.make(Curry._1(reduce, (function (direction) {
                                return /* Swipe */Block.__(2, [direction]);
                              })), /* Some */["App"], /* array */[
                          React.createElement("h1", {
                                className: "Title"
                              }, "Re-Tetris"),
                          ReasonReact.element(/* None */0, /* None */0, Board.make(Tetris.getBoard(state[/* game */0]), "board", state[/* isPaused */3], /* array */[])),
                          React.createElement("div", {
                                className: "Game-info"
                              }, elementState("Lines", Tetris.getLines(state[/* game */0])), elementState("Level", Tetris.getLevel(state[/* game */0])), elementState("Score", Tetris.getScore(state[/* game */0])), React.createElement("div", {
                                    className: "controls"
                                  }, React.createElement("a", {
                                        onClick: Curry._1(reduce, (function () {
                                                return /* TogglePause */2;
                                              }))
                                      }, "Help"), React.createElement("img", {
                                        src: match !== 0 ? mute : unmute,
                                        onClick: Curry._1(reduce, (function () {
                                                return /* ToggleSound */1;
                                              }))
                                      }))),
                          ReasonReact.element(/* None */0, /* None */0, Help.make(state[/* isPaused */3], /* array */[])),
                          ReasonReact.element(/* None */0, /* None */0, GameOver.make(1 - Tetris.isActive(state[/* game */0]), Tetris.getScore(state[/* game */0]), Curry._1(reduce, (function () {
                                          return /* Restart */3;
                                        })), /* array */[])),
                          React.createElement("audio", {
                                autoPlay: true,
                                loop: true,
                                muted: Js_boolean.to_js_boolean(state[/* isMuted */2]),
                                src: theme
                              })
                        ])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* game */Tetris.init(/* () */0),
              /* softDrop : false */0,
              /* isMuted : false */0,
              /* isPaused : false */0,
              /* timerId */[/* None */0]
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      var match = state[/* isPaused */3];
      var exit = 0;
      var exit$1 = 0;
      if (match !== 0) {
        if (typeof action === "number") {
          if (action) {
            exit$1 = 2;
          } else {
            return /* NoUpdate */0;
          }
        } else {
          switch (action.tag | 0) {
            case 0 : 
                exit = 1;
                break;
            case 2 : 
                return /* NoUpdate */0;
            default:
              exit$1 = 2;
          }
        }
      } else if (typeof action === "number") {
        if (action) {
          exit$1 = 2;
        } else {
          return takeAction(state, /* Down */4);
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var match$1 = action[0];
              var exit$2 = 0;
              if (match$1 >= 41) {
                var switcher = match$1 - 72 | 0;
                if (switcher > 33 || switcher < 0) {
                  exit$1 = 2;
                } else {
                  switch (switcher) {
                    case 0 : 
                        exit = 1;
                        break;
                    case 1 : 
                    case 2 : 
                    case 3 : 
                    case 4 : 
                    case 5 : 
                    case 6 : 
                    case 7 : 
                    case 8 : 
                    case 9 : 
                    case 10 : 
                    case 11 : 
                    case 12 : 
                    case 13 : 
                    case 14 : 
                    case 15 : 
                    case 17 : 
                    case 19 : 
                    case 20 : 
                    case 21 : 
                    case 22 : 
                    case 23 : 
                    case 24 : 
                        exit$1 = 2;
                        break;
                    case 26 : 
                        exit$2 = 3;
                        break;
                    case 28 : 
                        return takeAction(state, /* Left */0);
                    case 30 : 
                        return takeAction(state, /* Right */1);
                    case 18 : 
                    case 27 : 
                    case 31 : 
                        return takeAction(state, /* TurnLeft */2);
                    case 32 : 
                        return takeAction(state, /* HardDrop */5);
                    case 16 : 
                    case 25 : 
                    case 29 : 
                    case 33 : 
                        return takeAction(state, /* TurnRight */3);
                    
                  }
                }
              } else if (match$1 >= 17) {
                switch (match$1 - 17 | 0) {
                  case 0 : 
                      return takeAction(state, /* TurnLeft */2);
                  case 15 : 
                      return takeAction(state, /* HardDrop */5);
                  case 1 : 
                  case 2 : 
                  case 3 : 
                  case 4 : 
                  case 5 : 
                  case 6 : 
                  case 7 : 
                  case 8 : 
                  case 9 : 
                  case 10 : 
                  case 11 : 
                  case 12 : 
                  case 13 : 
                  case 14 : 
                  case 16 : 
                  case 17 : 
                  case 18 : 
                  case 19 : 
                      exit$1 = 2;
                      break;
                  case 20 : 
                      return takeAction(state, /* Left */0);
                  case 21 : 
                      return takeAction(state, /* TurnRight */3);
                  case 22 : 
                      return takeAction(state, /* Right */1);
                  case 23 : 
                      exit$2 = 3;
                      break;
                  
                }
              } else {
                exit$1 = 2;
              }
              if (exit$2 === 3) {
                return /* Update */Block.__(0, [/* record */[
                            /* game */state[/* game */0],
                            /* softDrop : true */1,
                            /* isMuted */state[/* isMuted */2],
                            /* isPaused */state[/* isPaused */3],
                            /* timerId */state[/* timerId */4]
                          ]]);
              }
              break;
          case 1 : 
              var match$2 = action[0];
              var exit$3 = 0;
              if (match$2 !== 40 && match$2 !== 98) {
                exit$1 = 2;
              } else {
                exit$3 = 3;
              }
              if (exit$3 === 3) {
                return /* Update */Block.__(0, [/* record */[
                            /* game */state[/* game */0],
                            /* softDrop : false */0,
                            /* isMuted */state[/* isMuted */2],
                            /* isPaused */state[/* isPaused */3],
                            /* timerId */state[/* timerId */4]
                          ]]);
              }
              break;
          case 2 : 
              switch (action[0]) {
                case 0 : 
                    return takeAction(state, /* Left */0);
                case 1 : 
                    return takeAction(state, /* Right */1);
                case 2 : 
                    return takeAction(state, /* TurnRight */3);
                case 3 : 
                    return takeAction(state, /* HardDrop */5);
                
              }
              break;
          
        }
      }
      if (exit$1 === 2) {
        var exit$4 = 0;
        if (typeof action === "number") {
          switch (action) {
            case 1 : 
                exit$4 = 3;
                break;
            case 2 : 
                exit = 1;
                break;
            case 3 : 
                return /* Update */Block.__(0, [/* record */[
                            /* game */Tetris.init(/* () */0),
                            /* softDrop */state[/* softDrop */1],
                            /* isMuted */state[/* isMuted */2],
                            /* isPaused */state[/* isPaused */3],
                            /* timerId */state[/* timerId */4]
                          ]]);
            
          }
        } else if (action.tag) {
          return /* NoUpdate */0;
        } else if (action[0] !== 77) {
          return /* NoUpdate */0;
        } else {
          exit$4 = 3;
        }
        if (exit$4 === 3) {
          return /* Update */Block.__(0, [/* record */[
                      /* game */state[/* game */0],
                      /* softDrop */state[/* softDrop */1],
                      /* isMuted */1 - state[/* isMuted */2],
                      /* isPaused */state[/* isPaused */3],
                      /* timerId */state[/* timerId */4]
                    ]]);
        }
        
      }
      if (exit === 1) {
        return /* Update */Block.__(0, [/* record */[
                    /* game */state[/* game */0],
                    /* softDrop */state[/* softDrop */1],
                    /* isMuted */state[/* isMuted */2],
                    /* isPaused */1 - state[/* isPaused */3],
                    /* timerId */state[/* timerId */4]
                  ]]);
      }
      
    });
  return newrecord;
}

exports.theme        = theme;
exports.mute         = mute;
exports.unmute       = unmute;
exports.elementState = elementState;
exports.takeAction   = takeAction;
exports.setTimer     = setTimer;
exports.component    = component;
exports.make         = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/App.re
// module id = 26
// module chunks = 0